import React from 'react'

const ClockClockwiseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_11228_5187)'>
        <path
          d='M10 6.25V10L13.125 11.875'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.375 8.125H17.5V5'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.7183 14.9998C13.7355 15.9272 12.5013 16.5444 11.1697 16.7743C9.83816 17.0042 8.46838 16.8366 7.23153 16.2925C5.99468 15.7483 4.9456 14.8518 4.21537 13.7148C3.48513 12.5779 3.10614 11.251 3.12572 9.89986C3.14531 8.54875 3.56262 7.23337 4.3255 6.11807C5.08838 5.00277 6.16301 4.137 7.41512 3.62896C8.66723 3.12091 10.0413 2.9931 11.3656 3.26151C12.6899 3.52991 13.9058 4.18263 14.8613 5.1381C15.7808 6.06935 16.5402 6.94747 17.4996 8.12482'
          stroke='#666666'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_11228_5187'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ClockClockwiseIcon
